/**
 * サンプルデータ Dropdown.Menu 内の共通項目（空状態ヒーロー / 充填後ツールバー）
 */

import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { StandardDatasetEntry } from '../../../../services/systems/keisuke/keisukeStandardDatasets';

export type KeisukeSampleDataMenuItemsProps = {
  tutorialForType: StandardDatasetEntry[];
  verificationForType: StandardDatasetEntry[];
  hasAnySample: boolean;
  onLoadSampleData: (entry: StandardDatasetEntry) => void;
  /** 緑CTAと同じサンプルはメニューから外す（二重表示を避ける） */
  excludeSampleId?: string | null;
};

export default function KeisukeSampleDataMenuItems({
  tutorialForType,
  verificationForType,
  hasAnySample,
  onLoadSampleData,
  excludeSampleId,
}: KeisukeSampleDataMenuItemsProps) {
  const { t } = useTranslation();
  const tutorialsFiltered = excludeSampleId
    ? tutorialForType.filter((e) => e.id !== excludeSampleId)
    : tutorialForType;
  const verificationsFiltered = excludeSampleId
    ? verificationForType.filter((e) => e.id !== excludeSampleId)
    : verificationForType;
  /** 除外すると空になる場合は緑CTAと二重でも残す（メニューが空っぽになるのを避ける） */
  const keepPrimaryInMenu =
    Boolean(excludeSampleId) &&
    tutorialsFiltered.length === 0 &&
    verificationsFiltered.length === 0;
  const tutorials = keepPrimaryInMenu ? tutorialForType : tutorialsFiltered;
  const verifications = keepPrimaryInMenu ? verificationForType : verificationsFiltered;

  return (
    <>
      <Dropdown.Header
        className="small text-muted fw-normal pb-0"
        style={{ whiteSpace: 'normal', maxWidth: '22rem' }}
      >
        {t('keisuke.dashboard.sampleDataMatchAnalysisHint')}
      </Dropdown.Header>
      {!hasAnySample ? (
        <Dropdown.Item disabled>{t('keisuke.dashboard.sampleDataNoMatch')}</Dropdown.Item>
      ) : (
        <>
          <Dropdown.Header>{t('keisuke.dashboard.sampleDataTutorial')}</Dropdown.Header>
          {tutorials.length > 0 ? (
            tutorials.map((entry) => (
              <Dropdown.Item key={entry.id} onClick={() => onLoadSampleData(entry)}>
                {t(entry.nameKey) || entry.id}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item disabled className="small text-muted">
              {t('keisuke.dashboard.sampleDataNoneInCategory')}
            </Dropdown.Item>
          )}
          <Dropdown.Divider />
          <Dropdown.Header>{t('keisuke.dashboard.sampleDataVerification')}</Dropdown.Header>
          {verifications.length > 0 ? (
            verifications.map((entry) => (
              <Dropdown.Item key={entry.id} onClick={() => onLoadSampleData(entry)}>
                {t(entry.nameKey) || entry.id}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item disabled className="small text-muted">
              {t('keisuke.dashboard.sampleDataNoneInCategory')}
            </Dropdown.Item>
          )}
        </>
      )}
    </>
  );
}
